<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>

    <div class="sdev-card">

        <h3 class="sdev-card-title">
            History
        </h3>

        <table class="sdev-table">

            <thead>

                <tr>

                    <th>Event</th>
                    <th>Type</th>
                    <th>Date</th>

                </tr>

            </thead>

            <tbody>

                <tr v-for="event in history" :key="event.event_id">

                    <td>{{ event.event_key }}</td>
                    <td>{{ event.event_type }}</td>
                    <td>{{ event.created_at }}</td>

                </tr>

            </tbody>

        </table>

    </div>

</template>